export function isFunction (func) {
  return (typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]')
}

export function snapToGrid (grid, pendingX, pendingY, scale = 1) {
  const x = Math.round((pendingX / scale) / grid[0]) * grid[0]
  const y = Math.round((pendingY / scale) / grid[1]) * grid[1]

  return [x, y]
}

export function getSize (el) {
  const rect = el.getBoundingClientRect()

  return [
    parseInt(rect.width),
    parseInt(rect.height)
  ]
}

export function getCoordinate (cx, cy, rotate, x0, y0) {
  const left_top = getXY(cx, cy, x0, y0, rotate)
  const left_bottom = getXY(cx, cy, x0, (2 * cy - y0), rotate)
  const right_top = getXY(cx, cy, (2 * cx - x0), y0, rotate)
  const right_bottom = getXY(cx, cy, (2 * cx - x0), (2 * cy - y0), rotate)
  return [left_top, right_top, right_bottom, left_bottom]
}

function getXY (xcenter, ycenter, x0, y0, rotate) {
  const x = Math.cos(rotate) * (x0 - xcenter) - Math.sin(rotate) * (y0 - ycenter) + xcenter
  const y = Math.sin(rotate) * (x0 - xcenter) + Math.cos(rotate) * (y0 - ycenter) + ycenter
  return { x: x, y: y }
}

export function computeWidth (parentWidth, left, right) {
  return parentWidth - left - right
}

export function computeHeight (parentHeight, top, bottom) {
  return parentHeight - top - bottom
}

export function computeRotate ({oraginX,oraginY}, {touchX,touchY}, {resizeX,resizeY},rotate) {
  console.log({oraginX,oraginY}, {touchX,touchY}, {resizeX,resizeY})
  const dot = (touchX - oraginX) * (resizeX - oraginX) + (touchY-oraginY) * (resizeY-oraginY)
  const det = (touchX - oraginX) * (resizeY-oraginY) - (touchY-oraginY) * (resizeX - oraginX)
  const angle = Math.atan2(det, dot) / Math.PI * 360 + rotate
  return angle % 360 
}

export function restrictToBounds (value, min, max) {
  if (min !== null && value < min) {
    return min
  }

  if (max !== null && max < value) {
    return max
  }

  return value
}
